// extracted by mini-css-extract-plugin
export var button = "bW_ns";
export var button__darkBlue = "bW_nx";
export var button__edgesGrey = "bW_ny";
export var button__edgesRed = "bW_nv";
export var button__loader = "bW_nz";
export var button__red = "bW_nt";
export var button__transparent = "bW_nw";
export var loadingSpinner = "bW_nB";